import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Search(props) {
    return (
        <SvgIcon {...props} fill="none">
            <path d="M14.8933 13.669L10.3438 9.11875C11.0435 8.2 11.4373 7.01875 11.4373 5.74972C11.4373 2.59972 8.90007 0.0625 5.75007 0.0625C2.60007 0.0625 0.0620117 2.60056 0.0620117 5.75056C0.0620117 8.90056 2.59923 11.4378 5.74923 11.4378C7.01826 11.4378 8.1552 11.044 9.11826 10.3443L13.6685 14.8946C13.8433 15.0693 14.0623 15.1571 14.2813 15.1571C14.5004 15.1571 14.7185 15.0693 14.8941 14.8946C15.2436 14.5443 15.2436 14.0193 14.8933 13.6691L14.8933 13.669ZM5.75007 9.68806C3.56229 9.68806 1.81257 7.93834 1.81257 5.75056C1.81257 3.56278 3.56229 1.81306 5.75007 1.81306C7.93785 1.81306 9.68757 3.56278 9.68757 5.75056C9.68757 7.9375 7.93703 9.68806 5.75007 9.68806Z" fill="#A3A3A3" />
        </SvgIcon>
    );
}

Search.defaultProps = {
    viewBox: '0 0 16 16'
};

export default Search;
